var exports = {
  "Er": "ChannelOverviewTab.module__regionOption___OU4wd1",
  "pG": "ChannelOverviewTab.module__regionEmoji___OU4wd1",
  "Kj": "ChannelOverviewTab.module__regionEmojiText___OU4wd1",
  "c5": "ChannelOverviewTab.module__topicInput___OU4wd1",
  "Z8": "ChannelOverviewTab.module__emojiButton___OU4wd1",
  "IJ": "ChannelOverviewTab.module__emojiButtonInactive___OU4wd1",
  "Dg": "ChannelOverviewTab.module__emojiButtonActive___OU4wd1",
  "p9": "ChannelOverviewTab.module__sectionWrapper___OU4wd1",
  "h3": "ChannelOverviewTab.module__settingsGroup___OU4wd1",
  "hB": "ChannelOverviewTab.module__settingsControlRow___OU4wd1",
  "S8": "ChannelOverviewTab.module__settingsControlRowStacked___OU4wd1",
  "Y4": "ChannelOverviewTab.module__settingsControlText___OU4wd1",
  "vK": "ChannelOverviewTab.module__settingsControlTitleRow___OU4wd1",
  "H1": "ChannelOverviewTab.module__settingsControlLabel___OU4wd1",
  "H7": "ChannelOverviewTab.module__settingsControlDescription___OU4wd1",
  "yN": "ChannelOverviewTab.module__settingsSliderControl___OU4wd1",
};

module.exports = exports;
